<template>
  <v-row no-gutters class="py-8 pl-4 pr-8">
    <v-col cols="12">
      <div class="text-h6 pl-3">Report Management</div>
      <div>
        <PrimaryFiltersVT
          :list_filters="config.tabs"
          @filter_update="update_current_tab($event)"
          :current_tab="current_tab"
        ></PrimaryFiltersVT>
      </div>
      <v-row class="pl-4" no-gutters v-if="current_tab == 'Reports'">
        <v-col cols="12">
          <div class="d-flex my-3" v-for="(report, indx) in report_list" :key="`${report}_${indx}`">
            <div class="width-20">
              {{ report.ReportName }}
            </div>
            <div class="primary--text width-10 mr-5">
              <span>{{ report.SendTime }}</span>
            </div>
            <div class="mr-8">
              <DaysSelector hide_title="true" :config="config.days" :items="report.Days" />
            </div>
            <div v-if="report.ReportID != 1">
              <v-icon @click="get_report_id(report.ReportID)">mdi-delete-circle</v-icon>
            </div>
          </div>
        </v-col>
      </v-row>
      <v-row class="pl-4" no-gutters v-if="current_tab == 'Schedule'">
        <v-col cols="4 pt-4">
          <v-select
            dense
            v-model="report"
            color="primaryDark"
            :items="report_list"
            item-text="ReportName"
            return-object
            label="Select Report"
            @change="fetch_report_details($event)"
          ></v-select>
        </v-col>
        <v-col cols="12" v-if="schedule_edit">
          <v-row class="pt-5 pb-3" no-gutters>
            <v-col
              v-for="(tab_obj, indx) in config.edit_tabs"
              :key="`${tab_obj.value}_${indx}`"
              cols="auto"
              @click="tab_selected = tab_obj.value"
              :class="`px-2 mr-2 text-caption font-weight-bold edit_tab ${
                tab_selected == tab_obj.value ? 'tab-highlighted' : ''
              }`"
              >{{ tab_obj.label }}</v-col
            >
          </v-row>
          <div v-if="tab_selected == 'recipients'">
            <div>
              <div
                class="d-flex"
                v-for="(recipient, indx) in recipients_list"
                :key="`${recipient.ReportRecipientID}_${indx}`"
              >
                <div class="width-30">
                  <span>{{ recipient.RecipientName }}</span
                  ><span class="text-caption primary--text">({{ recipient.RecipientEmail }})</span>
                </div>
                <div>
                  <v-icon @click="delete_recipient(recipient)" small>mdi-trash-can</v-icon>
                </div>
              </div>
              <div class="d-flex mt-4">
                <v-text-field
                  class="mr-4"
                  dense
                  color="primaryDark"
                  v-model="new_recipient.RecipientName"
                  label="Name"
                ></v-text-field>
                <v-text-field
                  class="mr-4"
                  dense
                  color="primaryDark"
                  v-model="new_recipient.RecipientEmail"
                  label="Email"
                ></v-text-field>
                <v-btn
                  small
                  :disabled="validate_recipient"
                  class="mr-4 bold"
                  dense
                  color="primary"
                  @click="add_recipient(new_recipient)"
                  >Add New Recipient</v-btn
                >
                <v-btn small class="mr-4 bold" dense outlined @click="clear">Clear</v-btn>
              </div>
            </div>
          </div>
          <v-form ref="form" v-if="tab_selected == 'schedule'" v-model="valid">
            <v-row class="pb-6">
              <v-col cols="12">
                <div class="mb-2">
                  <DaysSelector :config="config.days" :items="schedule_edit.Days" @update_schedule="update_schedule" />
                </div>
              </v-col>
              <v-col cols="12">
                <v-select
                  class="width-fxd-30"
                  dense
                  color="primaryDark"
                  v-model="schedule_edit.SendTime"
                  :items="config.time"
                  label="Select Time"
                ></v-select>
              </v-col>
              <!-- <v-col cols="12">
                <v-text-field
                  dense
                  class="width-fxd-30"
                  color="primaryDark"
                  v-model="schedule_edit.LocationID"
                  label="POI ID"
                  :counter="100"
                  :rules="maxRule(100, false)"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-select
                  class="width-fxd-30"
                  dense
                  color="primaryDark"
                  v-model="schedule_edit.ReportType"
                  :items="config.reportType"
                  label="Report Type"
                ></v-select>
              </v-col> -->
            </v-row>
            <v-row>
              <v-spacer></v-spacer>
              <v-col cols="auto">
                <v-btn dense color="primary" @click="validate()" class="bold" :disabled="!valid">Save</v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-col>
      </v-row>
      <v-row class="pl-4" no-gutters v-if="current_tab == 'AddNewReport'">
        <v-form ref="new_report_form" v-model="valid_new_report">
          <v-row no-gutters>
            <v-col cols="6">
              <v-row no-gutters class="mr-10">
                <v-col cols="12">
                  <v-text-field
                    dense
                    color="primaryDark"
                    v-model="new_report.ReportName"
                    label="Name"
                    :counter="50"
                    :rules="maxRule(50, true)"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-autocomplete
                    v-if="!isPowerData"
                    dense
                    color="primaryDark"
                    v-model="new_report.LocationID"
                    :items="poi_list"
                    item-text="FullName"
                    :disabled="new_report.ReportType == 'KPI'"
                    label="POI"
                    item-value="LocationID"
                  ></v-autocomplete>
                  <v-autocomplete
                    v-if="isPowerData"
                    dense
                    color="primaryDark"
                    :items="device_list"
                    v-model="new_report.DeviceID"
                    item-text="DeviceID"
                    label="Device"
                    item-value="DeviceID"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12">
                  <v-select
                    v-if="!isPowerData"
                    dense
                    color="primaryDark"
                    v-model="new_report.ReportType"
                    :items="config.reportType"
                    @change="update_locationId($event)"
                    label="Report Type"
                  ></v-select>
                  <v-select
                    v-else
                    dense
                    color="primaryDark"
                    v-model="new_report.ReportType"
                    :items="config.reportTypePowerdata"
                    label="Report Type"
                  ></v-select>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="6">
              <v-row no-gutters>
                <v-col cols="12" class="mb-6">
                  <DaysSelector :config="config.days" :items="new_report.Days" @update_schedule="new_schedule" />
                </v-col>
                <v-col cols="4">
                  <v-select
                    dense
                    color="primaryDark"
                    v-model="new_report.SendTime"
                    :items="config.time"
                    label="Select Time"
                  ></v-select>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12">
              <v-row>
                <v-spacer></v-spacer>
                <v-col cols="auto">
                  <v-btn dense outlined class="mr-2 bold" @click="clear_new_report">Clear</v-btn>
                  <v-btn dense color="primary" @click="validate_new_report()" class="bold" :disabled="!valid_new_report"
                    >Save</v-btn
                  >
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-form>
      </v-row>
    </v-col>
    <ConfirmationDialogVT
      v-if="showDeleteDialog"
      :id="dialog_report_id"
      :buttonText="'Delete'"
      :text="'This report will be deleted!'"
      @confirm_action="delete_report"
      @closeDialog="showDeleteDialog = false"
    />
    <v-snackbar color="borderDark" v-model="snackbar" timeout="2000">{{ error_message }}</v-snackbar>
  </v-row>
</template>

<script>
import PrimaryFiltersVT from "./PrimaryFiltersVT";
import DaysSelector from "./DaysSelector";
import ConfirmationDialogVT from "./ConfirmationDialogVT.vue";
import { axios_get, axios_post, axios_delete, axios_put } from "../services/vt_service";
import { tracking } from "../services/tracking";
import { content } from "../../config/reports_management.js";

export default {
  name: "ReportManagement",
  watch: {},
  components: { PrimaryFiltersVT, DaysSelector, ConfirmationDialogVT },
  props: {
    isPowerData: Boolean,
    deviceId: String,
  },
  data: function () {
    return {
      config: null,
      valid: false,
      valid_new_report: false,
      current_tab: "Reports",
      report: null,
      report_id: null,
      report_list: null,
      recipients_list: null,
      schedule: null,
      schedule_edit: null,
      new_report: null,
      tab_selected: "schedule",
      snackbar: false,
      error_message: "",
      new_recipient: {
        RecipientName: "",
        RecipientEmail: "",
      },
      maxAndRequiredRule: [
        (v) => !!v || "This field is required",
        (v) => (v && v.length <= 50) || "Must be less than 50 characters",
      ],
      requiredRule: [(v) => !!v || "This field is required"],
      showDeleteDialog: false,
      dialog_report_id: null,
      device_id: null,
    };
  },
  mounted() {
    this.get_report_list();
    this.device_id = this.deviceId;
  },
  created() {
    this.config = content;
  },
  methods: {
    clear_new_report() {
      this.new_report = {
        ReportName: "",
        Schedule: "Daily",
        Days: "0000000",
        SendTime: "09:00",
        ReportType: "",
        Path: "",
      };
      if (this.isPowerData) {
        this.new_report.DeviceID = "";
      } else {
        this.new_report.LocationID = "";
      }
    },
    update_locationId(event) {
      if (event == "KPI") {
        // this.$nextTick(() => {
        this.new_report.LocationID = "";
        // });
      }
    },
    async get_report_list() {
      this.network_error = false;
      let response = await axios_get(tracking.get_report_list);
      this.report_list = response[0];
    },
    async fetch_report_details(obj) {
      this.report_id = obj ? obj.ReportID : this.report_id;
      this.network_error = false;
      let schedule_res = await axios_get(tracking.get_report_schedule, { id: this.report_id });
      let recipients_res = await axios_get(tracking.get_report_recipients_list, { id: this.report_id });
      this.schedule = schedule_res[0][0];
      this.schedule_edit = JSON.parse(JSON.stringify(schedule_res[0][0]));
      this.recipients_list = recipients_res[0];
    },
    allowedStep: (m) => m % 30 === 0,
    update_current_tab(val) {
      this.new_report = {
        ReportName: "",
        Schedule: "Daily",
        Days: "0000000",
        SendTime: "09:00",
        ReportType: "",
        Path: "",
      };
      if (this.isPowerData) {
        this.new_report.DeviceID = "";
      } else {
        this.new_report.LocationID = "";
      }
      this.report = null;
      this.schedule_edit = null;
      this.current_tab = val;
    },
    selected_days: function (val) {
      return val == 1 ? "primary" : "primaryGrey";
    },
    clear: function () {
      this.new_recipient = {
        RecipientName: "",
        RecipientEmail: "",
      };
    },
    update_schedule: function (indx) {
      let replacement = this.schedule_edit.Days[indx] == "0" ? "1" : "0";
      this.schedule_edit.Days =
        this.schedule_edit.Days.substr(0, indx) +
        replacement +
        this.schedule_edit.Days.substr(indx + replacement.length);
    },
    new_schedule: function (indx) {
      let replacement = this.new_report.Days[indx] == "0" ? "1" : "0";
      this.new_report.Days =
        this.new_report.Days.substr(0, indx) + replacement + this.new_report.Days.substr(indx + replacement.length);
    },
    delete_recipient: async function (recipient) {
      this.network_error = false;
      await axios_delete(tracking.delete_report_recipient, {
        report_id: this.report_id,
        recipient_id: recipient.ReportRecipientID,
      });
      this.error_message = "Recipient deleted successfully!";
      this.snackbar = true;
      this.fetch_report_details();
    },
    get_report_id(id) {
      this.dialog_report_id = id;
      this.showDeleteDialog = true;
    },
    delete_report: async function (payload) {
      const { id } = payload;
      this.network_error = false;
      await axios_delete(tracking.delete_report, { id });
      this.error_message = "Report deleted successfully!";
      this.snackbar = true;
      this.get_report_list();
      this.showDeleteDialog = false;
    },
    add_recipient: async function (recipient) {
      this.network_error = false;
      await axios_post(tracking.add_report_recipient, recipient, { id: this.report_id });
      this.error_message = "Recipient added successfully!";
      this.snackbar = true;
      this.clear();
      this.fetch_report_details();
    },
    update_report_schedule: async function () {
      this.network_error = false;
      let temp = {
        Days: this.schedule_edit.Days,
        SendTime: this.schedule_edit.SendTime,
        ReportType: this.schedule_edit.ReportType,
      };
      if (this.isPowerData) {
        temp.DeviceID = this.schedule_edit.LocationID;
      } else {
        temp.LocationID = this.schedule_edit.LocationID;
      }
      await axios_put(tracking.update_report, { id: this.report_id }, temp);
      this.error_message = "Report updated successfully!";
      this.snackbar = true;
      this.get_report_list();
      this.fetch_report_details();
      this.current_tab = "Reports";
    },
    maxRule: function (characters, isRequired) {
      return isRequired
        ? [
            (v) => !!v || "This field is required",
            (v) => (v && v.length <= characters) || `Must be less than ${characters} characters`,
          ]
        : [(v) => !v || (v && v.length <= characters) || `Must be less than ${characters} characters`];
    },
    validate: function () {
      if (this.$refs.form.validate()) {
        this.update_report_schedule();
      }
    },
    validate_new_report: function () {
      if (this.$refs.new_report_form.validate()) {
        this.add_new_report();
      }
    },
    add_new_report: async function () {
      this.network_error = false;
      if (this.new_report.ReportType == "KPI") {
        this.new_report.LocationID = "";
      } else if (this.new_report.LocationID) {
        this.new_report.ReportType = "POI";
      }
      if (this.new_report.DeviceID) {
        this.new_report.ReportType = "Device";
      }
      await axios_post(tracking.add_report, this.new_report);
      this.error_message = "Report added successfully!";
      this.snackbar = true;
      this.get_report_list();
      this.current_tab = "Reports";
      this.clear_new_report();
    },
  },
  computed: {
    validate_recipient() {
      let pattern =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return !(this.new_recipient.RecipientName && pattern.test(this.new_recipient.RecipientEmail));
    },
    poi_list: function () {
      let locations = this.$store.state.locations ? JSON.parse(JSON.stringify(this.$store.state.locations)) : [];
      return locations;
    },
    poi_obj: function () {
      let temp = this.poi_list
        ? this.poi_list.reduce(function (map, obj) {
            map[obj.LocationID] = obj;
            return map;
          }, {})
        : {};
      return temp;
    },
    device_list: function () {
      if (this.device_id) return [this.device_id];
      let devices = this.$store.state.devices ? JSON.parse(JSON.stringify(this.$store.state.devices)) : [];
      console.log(devices, this.$store.state.devices);
      return devices;
    },
    device_obj: function () {
      let temp = this.poi_list
        ? this.poi_list.reduce(function (map, obj) {
            map[obj.DeviceID] = obj;
            return map;
          }, {})
        : {};
      return temp;
    },
  },
};
</script>
<style lang="scss" scoped>
.opaque {
  opacity: 0.7;
}
div.tab-highlighted {
  border-bottom: 4px solid var(--v-borderDark-base);
}
div.pointer,
div.edit_tab {
  cursor: pointer;
}
div.width-30 {
  min-width: 30%;
}
div.width-fxd-30 {
  width: 30%;
}
div.width-10 {
  min-width: 10%;
}
div.width-20 {
  min-width: 20%;
}
</style>
